export enum OfferSwitcherTypeEnum {
  INDIVIDUAL = 'individual',
  BUSINESS = 'business'
}
